var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuBookmarks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#979797",
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.75 28.72-.5-.28c-2.6-1.48-4.99-3.33-7.08-5.48-2.93-3.12-4.42-6.32-4.42-9.65 0-4.3 3-7.67 6.82-7.67a6 6 0 0 1 5.18 3.12 6 6 0 0 1 5.18-3.12c3.82 0 6.82 3.37 6.82 7.67 0 3.3-1.49 6.53-4.42 9.65-2.08 2.16-4.47 4-7.08 5.47l-.5.3ZM11.57 7.64c-2.75 0-4.82 2.44-4.82 5.67 0 2.76 1.31 5.55 3.88 8.33a28.92 28.92 0 0 0 6.12 4.77c2.25-1.3 4.3-2.91 6.12-4.77 2.57-2.78 3.88-5.57 3.88-8.33 0-3.23-2.07-5.67-4.82-5.67a4 4 0 0 0-3.5 2.22l-1.68 2.57-1.67-2.57a4 4 0 0 0-3.5-2.22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBookmarks);
export default __webpack_public_path__ + "static/media/menu-bookmarks.c4673dc08c7e4f265eacbc9de63a7d5a.svg";
export { ForwardRef as ReactComponent };